import { postSearchApi, postFeedbackApi, postSearchDocumentsGoodApi } from "@/apis/search";
import { SearchFormModel } from "@/pages/Search/search-form-model";
import { PostApiClient } from "@/utils/api-client";
import { DataSchema } from "common";
import { sortOptions } from "@/@types/search";

export class SearchUsecase {
  static search(apiClient: PostApiClient, data: SearchFormModel) {
    const sort = sortOptions.find((sortOption) => data.sort == sortOption.value)!;
    const apiData: DataSchema.SearchRequest = {
      ...data,
      keyphrase: data.keyphrase ?? "",
      sort: { field: sort.field, order: sort?.order },
    };
    return postSearchApi(apiClient, apiData);
  }

  static goodFeedback(
    apiClient: PostApiClient,
    data: { queryId: string; documentId: string; searchDocumentId: string },
  ) {
    return postFeedbackApi(apiClient, {
      queryId: data.queryId,
      documentId: data.documentId,
      searchDocumentId: data.searchDocumentId,
      relevance: "RELEVANT",
    });
  }

  static searchDocumentsGood(apiClient: PostApiClient, data: { ids: string[] }) {
    return postSearchDocumentsGoodApi(apiClient, data);
  }
}
